import { cn } from "src/common/utils";

const SocketIcon = ({ className }: { className?: string }) => (
  <div className={cn(className, "flex items-center justify-center")}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 1000 1000"
      clipRule="evenodd"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit={2}
    >
      <linearGradient
        id="socket-icon-gradient"
        gradientTransform="matrix(755.939 0 0 1000 122.03 499.97)"
        gradientUnits="userSpaceOnUse"
        x1="0"
        x2="1"
        y1="0"
        y2="0"
      >
        <stop offset="0" stopColor="#f0a" />
        <stop offset="1" stopColor="#8c50ff" />
      </linearGradient>
      <path d="m309.906 170.343h355.43v653.648h-355.43z" fill="#fff" />
      <path
        d="m122.03 465.44c0 246.666 157.434 456.53 377.69 534.53 109.84-38.788 204.467-110.833 271.395-203.758 67.352-93.197 106.855-207.303 106.855-330.772v-329.061l-378.114-136.409-377.689 136.409v329.061zm312.186-253.758h175.344l-53.716 182.864h95.491l-261.031 393.575 61.958-285.742h-103.733z"
        fill="url(#socket-icon-gradient)"
        fillRule="nonzero"
      />
    </svg>
  </div>
);

export default SocketIcon;
